import { render, staticRenderFns } from "./Drones.vue?vue&type=template&id=6b8a2d60&"
import script from "./Drones.vue?vue&type=script&lang=js&"
export * from "./Drones.vue?vue&type=script&lang=js&"
import style0 from "./Drones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports